module.exports = __webpack_public_path__ + "static/img/jiat-special-vehicle.bb1ad8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/jiat-special-vehicle.jpg
// module id = BFWH
// module chunks = 0